export const eventTracker = (eventName, additionalPayload = {}) => {
  if(eventName){
    ChrAnalytics.trackEvent(eventName, additionalPayload);
  }
};

export const getEventDetails = (eventDetails) => {
  return {
    eventName: eventDetails?.eventName,
    payload: eventDetails?.payload ?? {}
  };
};